import { createSelector } from "reselect";

const selectPdcs = state => state.pdcs;

export const selectRanges = createSelector([selectPdcs], pdcs => pdcs.ranges);



// WEBPACK FOOTER //
// src/redux/selectors/pdcsSelector.js